const styles = {
  item: {
    fontSize: "1rem",
  },
};

export default styles;
